import Offcanvas from "react-bootstrap/Offcanvas";
import Button from "react-bootstrap/Button";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Label } from "./Label/Label";
import HelperService from "../utility/HelperService";
import PlotDatePicker from "./PlotDatePicker/PlotDatePicker";
import Select from "react-select";
import { Form } from "react-bootstrap";

interface PropData {
    isShow: boolean;
    isClose: any;
    data: any;
    showDate?: boolean;
    minDate?: Date | null;
    maxDate?: Date | null;
    type?: "EMI" | "CUSTOM" | null;
}

const emiTypeOptions: any[] = [
    { value: "MONTHLY", label: "Monthly" },
    { value: "QUARTERLY", label: "Quarterly" },
    { value: "HALF_YEARLY", label: "Half Yearly" },
    { value: "YEARLY", label: "Yearly" }
];


const AddScheduleModal = (props: PropData) => {
    const { register, handleSubmit, reset, formState: { errors }, watch, setValue, control } = useForm();
    const [title, setTitle] = useState("Add Schedule");

    const onCloseModal = (e: any) => {
        if (props.type === "EMI") {
            // e.emi_type
            if (e && e.emi_type && e.start_date && e.end_date) {
                const startDate = new Date(e.start_date);
                const endDate = new Date(e.end_date);
                let intervalMonths = 1;
                switch (e.emi_type) {
                    case "MONTHLY":
                        intervalMonths = 1;
                        break;
                    case "QUARTERLY":
                        intervalMonths = 3;
                        break;
                    case "HALF_YEARLY":
                        intervalMonths = 6;
                        break;
                    case "YEARLY":
                        intervalMonths = 12;
                        break;
                    default:
                        intervalMonths = 1;
                }
                // Calculate number of EMIs
                const emiDates = [];
                let current = new Date(startDate);
                let count = 0;
                while (current <= endDate) {
                    emiDates.push(new Date(current));
                    current = new Date(current.setMonth(current.getMonth() + intervalMonths));
                    count++;
                }
                // Divide percentage equally
                const totalPercentage = 100;
                const perEmi = Math.floor((totalPercentage / emiDates.length) * 100) / 100;
                let emiArray = emiDates.map((date, idx) => ({
                    id: idx + 1,
                    payment_date: date,
                    name: `EMI ${idx + 1}`,
                    percentage: perEmi
                }));
                // Adjust last EMI to fix floating point sum
                const sum = emiArray.reduce((acc, curr) => acc + curr.percentage, 0);
                if (sum !== totalPercentage && emiArray.length > 0) {
                    emiArray[emiArray.length - 1].percentage += totalPercentage - sum;
                }
                e.emiArray = emiArray;
                props.isClose(emiArray);
            } else {
                props.isClose('');
            }
        } else {
            props.isClose(e);
        }
        reset({});
    };

    useEffect(() => {
        if (props.isShow) {
            if (props.data && !HelperService.isEmptyObject(props.data)) {
                reset(props.data);
                setTitle("Edit Schedule");
            } else {
                reset({});
                setTitle("Add Schedule");
            }
        }
    }, [props.isShow, props.data]);


    return (
        <>
            <Offcanvas show={props.isShow} onHide={props.isClose} placement="end" className="offcanvas-large">
                <Offcanvas.Header closeButton><Offcanvas.Title>{title}</Offcanvas.Title></Offcanvas.Header>
                <Offcanvas.Body className="border-bottom px-0 information-main-view py-0">
                    {props.type ?
                        <>
                            {
                                props.type === "EMI" ?
                                    <form onSubmit={handleSubmit(onCloseModal)}>
                                        <div className="modal-body px-3 employee-mater-model">
                                            <div className=" service-address">
                                                <div className="service-location-form form-style">
                                                    <div className="row mt-3">
                                                        <Controller
                                                            control={control}
                                                            name="start_date"
                                                            rules={{ required: true, }}
                                                            render={({ field: { onChange } }) => (
                                                                <Form.Group className="mb-3">
                                                                    <Label title="Start Date" showStar={true} />
                                                                    <div className="input-group mb-1">
                                                                        <div className="col-12 form-group">
                                                                            <PlotDatePicker
                                                                                selected={watch("start_date") ? new Date(watch("start_date")) : null}
                                                                                maxData={props.maxDate ? new Date(props.maxDate) : null}
                                                                                minData={props.minDate ? new Date(props.minDate) : null}
                                                                                onChange={(date: any) => onChange(date)}
                                                                                placeholderText="Select Date"
                                                                            />
                                                                            {errors.start_date && (<Label title={"Please Select Start Date."} modeError={true} />)}
                                                                        </div>
                                                                    </div>
                                                                </Form.Group>
                                                            )}
                                                        />
                                                        <Controller
                                                            control={control}
                                                            name="end_date"
                                                            rules={{ required: true, }}
                                                            render={({ field: { onChange } }) => (
                                                                <Form.Group className="mb-3">
                                                                    <Label title="End Date" showStar={true} />
                                                                    <div className="input-group mb-1">
                                                                        <div className="col-12 form-group">
                                                                            <PlotDatePicker
                                                                                selected={watch("end_date") ? new Date(watch("end_date")) : null}
                                                                                maxData={props.maxDate ? new Date(props.maxDate) : null}
                                                                                minData={props.minDate ? new Date(props.minDate) : null}
                                                                                onChange={(date: any) => onChange(date)}
                                                                                placeholderText="Select Date"
                                                                            />
                                                                            {errors.end_date && (<Label title={"Please Select End Date."} modeError={true} />)}
                                                                        </div>
                                                                    </div>
                                                                </Form.Group>
                                                            )}
                                                        />
                                                        <Controller
                                                            control={control}
                                                            name="emi_type"
                                                            rules={{ required: true }}
                                                            render={({ field: { onChange } }) => (
                                                                <Form.Group className="mb-3">
                                                                    <Label title="EMI Type" showStar={true} />
                                                                    <div className="input-group mb-1">
                                                                        <Select
                                                                            className="basic-single w-100"
                                                                            classNamePrefix="select"
                                                                            isSearchable={true}
                                                                            options={emiTypeOptions}
                                                                            onChange={(e: any) => { onChange(e.value); }}
                                                                            value={emiTypeOptions?.filter((option: any) => watch().emi_type == option.value)}
                                                                            placeholder="Select EMI Type"
                                                                        />
                                                                    </div>
                                                                    {errors.emi_type && (
                                                                        <div className="login-error mb-3">
                                                                            <Label
                                                                                title={"Please Select EMI Type"}
                                                                                modeError={true}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </Form.Group>
                                                            )}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="offcanvas-footer position-absolute">
                                            <Button variant="primary" className="btn-brand-solid me-3" type="submit"> Save</Button>
                                            <Button variant="primary" className="btn-brand-outline" type="button" onClick={() => onCloseModal('')}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </form>
                                    :
                                    <form onSubmit={handleSubmit(onCloseModal)}>
                                        <div className="modal-body px-3 employee-mater-model">
                                            <div className=" service-address">
                                                <div className="service-location-form form-style">
                                                    <div className="row mt-3">
                                                        {
                                                            props.showDate &&
                                                            <Controller
                                                                control={control}
                                                                name="payment_date"
                                                                rules={{ required: true, }}
                                                                render={({ field: { onChange } }) => (
                                                                    <Form.Group className="mb-3">
                                                                        <Label title="Date" showStar={true} />
                                                                        <div className="input-group mb-1">
                                                                            <div className="col-12 form-group">
                                                                                <PlotDatePicker
                                                                                    selected={watch("payment_date") ? new Date(watch("payment_date")) : null}
                                                                                    maxData={props.maxDate ? new Date(props.maxDate) : null}
                                                                                    minData={props.minDate ? new Date(props.minDate) : null}
                                                                                    onChange={(date: any) => onChange(date)}
                                                                                    placeholderText="Select Date"
                                                                                />
                                                                                {errors.payment_date && (<Label title={"Please Select Date."} modeError={true} />)}
                                                                            </div>
                                                                        </div>
                                                                    </Form.Group>
                                                                )}
                                                            />
                                                        }
                                                        <div className="col-12 mb-3 form-group">
                                                            <Label title="Name" showStar={true} />
                                                            <input className="form-control input" type="text" {...register("name", { required: true })} value={watch("name")} />
                                                            {errors.name && (<Label title={"Please Enter Name."} modeError={true} />)}
                                                        </div>
                                                        <div className="col-12 form-group">
                                                            <Label title="Percentage (%)" showStar={true} />
                                                            <input className="form-control input" type="text" {...register("percentage", { required: true, max: 100 })}
                                                                onKeyPress={(e) => HelperService.allowNewDecimalValue(e)} value={watch("percentage")} />
                                                            {errors.percentage && (<Label title={"Please Enter Valid Percentage."} modeError={true} />)}
                                                        </div>
                                                        <div className="col-12 form-group">
                                                            <Label title="Amount (%)" showStar={true} />
                                                            <input className="form-control input" type="text" {...register("amount", { required: true, max: 100 })}
                                                                onKeyPress={(e) => HelperService.allowNewDecimalValue(e)} value={watch("amount")} />
                                                            {errors.amount && (<Label title={"Please Enter Valid Amount."} modeError={true} />)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="offcanvas-footer position-absolute">
                                            <Button variant="primary" className="btn-brand-solid me-3" type="submit"> Save</Button>
                                            <Button variant="primary" className="btn-brand-outline" type="button" onClick={() => onCloseModal('')}>Cancel</Button>
                                        </div>
                                    </form>
                            }
                        </>
                        : <form onSubmit={handleSubmit(onCloseModal)}>
                            <div className="modal-body px-3 employee-mater-model">

                                <div className=" service-address">
                                    <div className="service-location-form form-style">
                                        <div className="row mt-3">
                                            {
                                                props.showDate &&
                                                <Controller
                                                    control={control}
                                                    name="payment_date"
                                                    rules={{ required: true }}
                                                    render={({ field: { onChange } }) => (
                                                        <Form.Group className="mb-3">
                                                            <Label title="Date" showStar={true} />
                                                            <div className="input-group mb-1">
                                                                <div className="col-12 form-group">
                                                                    <PlotDatePicker
                                                                        selected={watch("payment_date") ? new Date(watch("payment_date")) : null}
                                                                        maxData={props.maxDate ? new Date(props.maxDate) : null}
                                                                        minData={props.minDate ? new Date(props.minDate) : null}
                                                                        onChange={(date: any) => onChange(date)}
                                                                        placeholderText="Select Date"
                                                                    />

                                                                </div>
                                                            </div>
                                                            {errors.payment_date && (
                                                                <Label
                                                                    title={"Please Select Date."}
                                                                    modeError={true}
                                                                />
                                                            )}
                                                        </Form.Group>
                                                    )}
                                                />
                                            }
                                            <div className="col-12 mb-3 form-group">
                                                <Label title="Name" showStar={true} />
                                                <input
                                                    className="form-control input"
                                                    type="text"
                                                    {...register("name", { required: true })}
                                                    value={watch("name")}
                                                ></input>
                                                {errors.name && (<Label title={"Please Enter Name."} modeError={true} />)}
                                            </div>
                                            {/* <div className="col-12 form-group">
                                                <Label title="Percentage (%)" showStar={true} />
                                                <input className="form-control input" type="text" {...register("percentage", { required: true, max: 100 })}
                                                    onKeyPress={(e) => HelperService.allowNewDecimalValue(e)} value={watch("percentage")} />
                                                {errors.percentage && (<Label title={"Please Enter Valid Percentage."} modeError={true} />)}
                                            </div> */}
                                            <div className="col-12 form-group">
                                                <Label title="Amount" showStar={true} />
                                                <input className="form-control input" type="text" {...register("amount", { required: true })}
                                                    onKeyPress={(e) => HelperService.allowNewDecimalValue(e)} value={watch("amount")} />
                                                {errors.amount && (<Label title={"Please Enter Valid Amount."} modeError={true} />)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="offcanvas-footer position-absolute">
                                <Button variant="primary" className="btn-brand-solid me-3" type="submit">Save</Button>
                                <Button variant="primary" className="btn-brand-outline" type="button" onClick={() => onCloseModal('')}>Cancel</Button>
                            </div>
                        </form>}
                </Offcanvas.Body>

            </Offcanvas >
        </>
    );
};

export default AddScheduleModal;
